const serializeQueryParams = () => Object.fromEntries(new URLSearchParams(window.location.search));

export default serializeQueryParams;
